
                  export default function (Component) {
                      Component.__source = "library/components/VabErrorLog/index.vue"
                  }
              